import Image from "next/image";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import { useSocialSignin } from "@/hooks/useSocialSignin";
import { Button } from "@/components/ui/button";

const ssoProviders = [
  {
    icon: `/assets/logo-google.svg`,
    type: CognitoHostedUIIdentityProvider.Google,
    label: "Google",
  },
  {
    icon: `/assets/logo-apple.svg`,
    type: CognitoHostedUIIdentityProvider.Apple,
    label: "Apple",
  },
];

interface SocialSigninProps {
  action?: "signin" | "signup";
}

export function SocialSignin(_props: SocialSigninProps) {
  const { initiateSocialSignin } = useSocialSignin();
  return (
    <div className="flex flex-col gap-4">
      {ssoProviders.map((provider) => (
        <Button
          type="button"
          variant={null}
          key={provider.type}
          onClick={() => initiateSocialSignin(provider.type)}
          className="w-full flex items-center justify-center gap-2 bg-white py-[10px] rounded border border-[#808080] cursor-pointer hover:bg-[#F7F9FC]"
        >
          <span className="flex w-[40px] justify-center">
            <Image
              width={24}
              height={24}
              src={provider.icon}
              alt={`${provider.type}-signin`}
            />
          </span>
          <span className="text-[#212529]">Continue with {provider.label}</span>
        </Button>
      ))}
    </div>
  );
}
